import { IconProps } from '@radix-ui/react-icons/dist/types'

export const CollapseIcon = (props: IconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 9.50006C14 10.3285 13.3284 11.0001 12.5 11.0001H11L11 10.0001H12.5C12.7761 10.0001 13 9.7762 13 9.50006L13 2.50006C13 2.22392 12.7761 2.00006 12.5 2.00006L5.5 2.00006C5.22386 2.00006 5 2.22392 5 2.50006V4.00002H9.5C10.3284 4.00002 11 4.67159 11 5.50002V12.5C11 13.3284 10.3284 14 9.5 14H2.5C1.67157 14 0.999998 13.3284 0.999998 12.5V5.50002C0.999998 4.67159 1.67157 4.00002 2.5 4.00002H4V2.50006C4 1.67163 4.67157 1.00006 5.5 1.00006H12.5C13.3284 1.00006 14 1.67163 14 2.50006V9.50006ZM10 5.50002C10 5.22388 9.77614 5.00002 9.5 5.00002H2.5C2.22386 5.00002 2 5.22388 2 5.50002V12.5C2 12.7762 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7762 10 12.5V5.50002Z"
        fill="currentColor"
      />
      <rect x="3.5" y="8.5" width="5" height="1" rx="0.5" fill="currentColor" />
    </svg>
  )
}

export const ExpandIcon = (props: IconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 9.5C14 10.3284 13.3284 11 12.5 11H11V10H12.5C12.7761 10 13 9.77614 13 9.5V2.5C13 2.22386 12.7761 2 12.5 2H5.5C5.22386 2 5 2.22386 5 2.5V3.99996H9.5C10.3284 3.99996 11 4.67153 11 5.49996V12.4999C11 13.3283 10.3284 13.9999 9.5 13.9999H2.5C1.67157 13.9999 1 13.3283 1 12.4999V5.49996C1 4.67153 1.67157 3.99996 2.5 3.99996H4V2.5C4 1.67157 4.67157 1 5.5 1H12.5C13.3284 1 14 1.67157 14 2.5V9.5ZM10 5.49996C10 5.22382 9.77614 4.99996 9.5 4.99996H2.5C2.22386 4.99996 2 5.22382 2 5.49996V12.4999C2 12.7761 2.22386 12.9999 2.5 12.9999H9.5C9.77614 12.9999 10 12.7761 10 12.4999V5.49996Z"
        fill="currentColor"
      />
      <path
        d="M8 8.5H4C3.72386 8.5 3.5 8.72386 3.5 9C3.5 9.27614 3.72386 9.5 4 9.5H8C8.27614 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.27614 8.5 8 8.5Z"
        fill="currentColor"
      />
      <path
        d="M6.5 11L6.5 7C6.5 6.72386 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.72386 5.5 7L5.5 11C5.5 11.2761 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.2761 6.5 11Z"
        fill="currentColor"
      />
    </svg>
  )
}
